/**
 * Centralized token storage utility.
 * Uses in-memory storage only — no sessionStorage/localStorage.
 * Authentication is persisted via httpOnly cookies set by the backend.
 * On page reload, the app calls /api/auth/me (cookie-based) to restore session.
 */

let _token = null;
let _user = null;

const PERMISSIONS_KEY = 'userPermissions';

export const tokenStore = {
  getToken: () => _token,
  setToken: (token) => { _token = token; },
  getUser: () => _user,
  setUser: (user) => { _user = user; },
  clear: () => {
    _token = null;
    _user = null;
    try { sessionStorage.removeItem(PERMISSIONS_KEY); } catch {}
  },
  getAuthHeaders: () => {
    return _token ? { Authorization: `Bearer ${_token}` } : {};
  },
};
